import React from 'react'
import { SvgIcon } from '@material-ui/core'

export function RuIcon(props) {
  return (
    <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g clip-path="url(#clip0_14505_4017)">
        <path
          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
          fill="#F0F0F0"
        />
        <path
          d="M19.378 13.478C19.78 12.3946 20 11.2229 20 9.99973C20 8.77652 19.78 7.6048 19.378 6.52148H0.621992C0.220039 7.6048 0 8.77652 0 9.99973C0 11.2229 0.220039 12.3946 0.621992 13.478L10 14.3475L19.378 13.478Z"
          fill="#0052B4"
        />
        <path
          d="M10.0011 19.9998C14.3007 19.9998 17.9661 17.286 19.3791 13.478H0.623047C2.03598 17.286 5.70141 19.9998 10.0011 19.9998Z"
          fill="#D80027"
        />
      </g>
      <defs>
        <clipPath id="clip0_14505_4017">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}
